export default from '../html';
